import { decimalToCents, parseMoneyInput } from '@/shared/format/money';
import { walletSource } from '@/modules/wallet/public';
import { billingSettingSource } from '@/modules/billing-setting/public';
import { communicationSettingSource } from '@/modules/communication-setting/public';
import { msg } from '@lingui/core/macro';
import { defineFilters } from '@/shared/filters/define-filters';
import { BILLING_STATUS } from './billing.enums';
const iso = (day: string) => new Date(`${day}T00:00:00-03:00`).toISOString();
export const billingFilters = defineFilters([
  {
    key: 'billingSettingId',
    type: 'entity',
    label: msg`Régua de cobrança`,
    source: billingSettingSource,
  },
  {
    key: 'communicationSettingId',
    type: 'entity',
    label: msg`Régua de comunicação`,
    source: communicationSettingSource(),
  },
  { key: 'searchString', type: 'search', label: msg`Todos` },
  {
    key: 'walletsCode',
    type: 'entity',
    source: walletSource(),
    multiple: true,
    label: msg`Código convênio`,
  },
  { key: 'documentNumber', type: 'text', label: msg`Nº do documento` },
  { key: 'payerName', type: 'text', label: msg`Nome do pagador` },
  { key: 'payerRegistrationNumber', type: 'document', label: msg`Documento do pagador` },
  {
    key: 'amount',
    type: 'text',
    label: msg`Valor de cobrança`,
    placeholder: msg`R$ 0,00`,
    toParam: (value: string) => {
      const decimal = parseMoneyInput(value);
      return decimal === null ? undefined : decimalToCents(decimal);
    },
  },
  { key: 'barCode', type: 'text', label: msg`Código de barras` },
  {
    key: 'ourNumber',
    type: 'text',
    label: msg`Nosso número`,
    toParam: (value: string) => {
      const raw = value.replace(/\D/g, '');
      return raw.length > 0 ? `${raw.slice(0, -1)}-${raw.slice(-1)}` : value;
    },
  },
  { key: 'statusesValue', type: 'status', label: msg`Status`, options: BILLING_STATUS },
  {
    key: 'initialDueDate',
    to: 'finalDueDate',
    type: 'dateRange',
    label: msg`Vencimento`,
    fromParam: iso,
    toParam: iso,
  },
  {
    key: 'initialSettlementDate',
    to: 'finalSettlementDate',
    type: 'dateRange',
    label: msg`Data do crédito`,
    fromParam: iso,
  },
  {
    key: 'initialCreatedDate',
    to: 'finalCreatedDate',
    type: 'dateRange',
    label: msg`Criação`,
    fromParam: iso,
  },
  { key: 'installmentId', type: 'text', label: msg`Parcelamento` },
  {
    key: 'firstInstructionDebtCollection',
    type: 'select',
    label: msg`Instrução de protesto`,
    options: [
      { value: '00', label: msg`Não envia protesto` },
      { value: '06', label: msg`Protestar automático` },
    ],
  },
] as const);
